App.filter('getSexFromIdentifier', function () {
    return function (identifier) {
        identifier = identifier || '';
        if (identifier) {

            if (correct(identifier)) {
                var ssn = identifier.split("");

                return (ssn[9] % 2 === 1) ? 'MALE' : 'FEMALE';
            } else {
                return '';
            }
            
            var all = identifier;
        }
        return all;
    };

    function correct(identifier) {
        var reg = /^[0-9]{11}$/;    
        if (reg.test(identifier)) {      
            var ssn = identifier.split("");
            var weights = [1,3,7,9], sum = 0, control = 0;

            for (var i = 0; i < 10; i++) {
                sum += ssn[i] * weights[i%4];
            }

            sum = sum % 10;
            if (sum != 0) {
                control = 10 - sum;
            }      

            if (control == ssn[10]) {
                return true;
            } else {
                return false;
            }     
        }
        else {    
            return false;      
        } 
    }
})